import { Box } from "@mui/material"
import { colors } from "../../../../styles/commonStyles"

export const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="20px"
    viewBox="0 -960 960 960"
    width="20px"
    fill="#00AF50"
  >
    <path d="M389-227 154-461l91-92 144 145 327-326 91 90-418 417Z" />
  </svg>
)

export const CircleIndicator = (props: any) => {
  const { color } = props
  return (
    <>
      <Box
        sx={{
          //   border: "1px solid red",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <Box
          sx={{
            backgroundColor: color ? color : colors.primaryWhite,
            height: "20px",
            width: "20px",
            borderRadius: "50%",
          }}
        ></Box>
      </Box>
    </>
  )
}

export const TickIndicator = (props: any) => {
  return (
    <>
      <Box
        sx={{
          //   border: "1px solid red",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        <CheckIcon />
      </Box>
    </>
  )
}
